import React, { useState } from "react";
import { Modal, Form, Select, Alert } from "antd";
import TenantApi from "../../common/Apis/TenantApi";
import { createDefaultTenant } from "../../../models/Tenant/TenantDTO";

const CurrencySetModal = ({
    open,
    onClose,
    tenant,
    onSuccess,
    onError,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [apiError, setApiError] = useState(null);

    const handleSave = () => {
        form.validateFields(["currency"])
            .then((values) => {
                setLoading(true);

                const payload = createDefaultTenant({
                    ...tenant,
                    currency: values.currency,
                });

                TenantApi.Edittenants(tenant?.id, payload)
                    .then(() => {
                        setLoading(false);
                        onSuccess?.();     // notify parent if needed
                        onClose();         // close modal
                    })
                    .catch((err) => {
                        setLoading(false);

                        setApiError(err?.apiError?.message || err?.message || "currency added failed");

                        onError?.(err?.apiError?.message || err?.message || "currency added failed");   // send error to parent
                    });
            })
            .catch(() => { });
    };

    return (
        <Modal
            title="Set Default Currency"
            open={open}
            onCancel={onClose}
            onOk={handleSave}
            okText="Save"
            confirmLoading={loading}
            centered
            width={500}
        >
            {apiError && <Alert message={apiError} type="error" showIcon className="mb-3" />}
            <Alert
                message="Please select this customer's default currency. This will be used for all currency-related operations for this customer."
                type="info"
                showIcon
                className="mb-3"
            />

            <Form form={form}>
                <Form.Item
                    name="currency"
                    rules={[{ required: true, message: "Please Select Currency" }]}
                >
                    <Select placeholder="Select Currency">
                        <option value="€">Euro</option>
                        <option value="$">Dollar</option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CurrencySetModal;
